"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _AmericanExpress = _interopRequireDefault(require("../../assets/AmericanExpress"));
var _MasterCard = _interopRequireDefault(require("../../assets/MasterCard"));
var _Visa = _interopRequireDefault(require("../../assets/Visa"));
var _templateObject, _templateObject2;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var SVG_MAPPINGS = {
  visa: _Visa["default"],
  mastercard: _MasterCard["default"],
  americanexpress: _AmericanExpress["default"]
};
var Card = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  display: inline-block;\n  margin: 0 5px;\n  width: 35px;\n"])));
var CardList = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  text-align: center;\n"])));
var CreditCardIcons = function CreditCardIcons(_ref) {
  var cards = _ref.cards;
  return _react["default"].createElement(CardList, null, _react.Children.toArray(cards.map(function (card) {
    var Svg = SVG_MAPPINGS[card];
    return _react["default"].createElement(Card, null, _react["default"].createElement(Svg, null));
  })));
};
CreditCardIcons.defaultProps = {
  cards: ['visa', 'mastercard', 'americanexpress']
};
var _default = exports["default"] = (0, _react.memo)(CreditCardIcons);